import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67686508"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "photo-container" }

import { ref, computed, onMounted, watch } from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import CarouselPicture from "@/components/carousel-pictures/carousel-picture.vue";
import AiImageEnhancerModal from "@/components/ai/ai-image-enhancer-modal.vue";
import { PictureIds } from "@/types/picture-management/picture-ids";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";
import { PropertyImageType } from "acquaint-api/constants/PropertyImageType";
import { DxToolbarItem } from "devextreme-vue/popup";
import { usePropertyHelper } from "@/utils/properties/usePropertyHelper";


export default /*#__PURE__*/_defineComponent({
  __name: 'ai-picture-select-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  showModal: {
    type: Boolean,
    required: true,
  },
  /**
   * The unique identifier for the record the pictures belong to.
   * @type {Number}
   * @required
   */
  propertyId: {
    type: Number,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:showModal",
  /**
   * Emitted when the user selects an image. Passes the selected image data to the parent component.
   */
  "imageSelected",
  /**
   * Emitted when no images are available for selection (e.g., empty gallery or fetch failure).
   */
  "noImagesAvailable",
  /**
   * Triggered when the modal is closed.
   */
  "modalClosed",
],
  setup(__props, { emit }) {

const props = __props;





const propertyHelper = usePropertyHelper();
const imageList = ref<PictureIds[]>([]);
const selectedImageId = ref<number | null>(null);
const displayAIImageModal = ref(false);

const showPopup = computed({
  get: () => props.showModal,
  set: (val: boolean) => emit("update:showModal", val),
});

const fetchPictures = async () => {
  imageList.value = [];

  try {
    const summary = await propertyHelper.fetchPropertyDataSummary(
      props.propertyId,
    );
    const count = summary?.pictureCount ?? 0;

    if (count === 0) {
      emit("noImagesAvailable");
      showPopup.value = false;
    }

    for (let i = 1; i <= count; i++) {
      imageList.value.push({
        id: i,
        key: `${i}-${Math.random()}`,
      });
    }
  } catch (err) {
    imageList.value = [];
  }
};

onMounted(() => {
  if (showPopup.value) {
    fetchPictures();
  }
});

watch(showPopup, (open) => {
  if (open) {
    selectedImageId.value = null;
    fetchPictures();
  }
});

const selectImage = (imageId: number) => {
  selectedImageId.value = imageId;
  emit("imageSelected", imageId);
};

const closeModal = () => {
  showPopup.value = false;
  emit("modalClosed");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    modelValue: showPopup.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showPopup).value = $event)),
    title: "Select Image",
    width: _unref(ModalWidth).Medium,
    height: "80vh",
    "show-close-confirmation-prompt": false
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imageList.value, (image) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["picture-holder", { selected: selectedImageId.value === image.id }]),
            key: image.key
          }, [
            _createVNode(CarouselPicture, {
              "record-id": props.propertyId,
              pictureNumber: image.id,
              type: _unref(PropertyImageType).PropertyImageWeb,
              onClick: ($event: any) => (selectImage(image.id))
            }, null, 8, ["record-id", "pictureNumber", "type", "onClick"])
          ], 2))
        }), 128))
      ]),
      _createVNode(AiImageEnhancerModal, {
        modelValue: displayAIImageModal.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((displayAIImageModal).value = $event)),
        propertyId: props.propertyId,
        imageToDisplay: selectedImageId.value ?? -1,
        onAiResponseSaved: closeModal
      }, null, 8, ["modelValue", "propertyId", "imageToDisplay"])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Enhance',
          icon: 'fa-solid fa-microchip-ai',
          disabled: selectedImageId.value === null,
          onClick: () => (displayAIImageModal.value = true),
        }
      }, null, 8, ["options"]),
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "before",
        options: {
          text: 'Cancel',
          onClick: closeModal,
        }
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["modelValue", "width"]))
}
}

})